export const appPageTransition = {"name":"page","mode":"out-in"}

export const appHead = {"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"name":"twitter:card","content":"summary_large_image"}],"link":[],"style":[{"hid":"css-variables","children":":root { --font-family-primary:\"Roboto\", \"Helvetica Neue\", Arial, \"Noto Sans\", sans-serif;--font-family-secondary:\"Spartan\", \"Helvetica Neue\", Arial, \"Noto Sans\", sans-serif;--font-size-xxs:0.75rem;--font-size-xs:0.9375rem;--font-size-sm:1rem;--font-size-md:1.125rem;--font-size-lg:1.25rem;--font-size-xl:1.375rem;--font-size-2xl:1.5rem;--font-size-3xl:1.625rem;--font-size-4xl:1.875rem;--font-size-5xl:2rem;--font-size-6xl:2.125rem;--font-size-7xl:2.3125rem;--font-size-8xl:2.375rem;--font-size-9xl:3rem;--font-weight-primary-hairline:400;--font-weight-primary-thin:400;--font-weight-primary-light:400;--font-weight-primary-normal:400;--font-weight-primary-medium:400;--font-weight-primary-semibold:700;--font-weight-primary-bold:700;--font-weight-primary-extrabold:700;--font-weight-primary-black:700;--font-weight-secondary-hairline:600;--font-weight-secondary-thin:600;--font-weight-secondary-light:600;--font-weight-secondary-normal:600;--font-weight-secondary-medium:600;--font-weight-secondary-semibold:600;--font-weight-secondary-bold:700;--font-weight-secondary-extrabold:700;--font-weight-secondary-black:700;--lineHeight-xxs:1;--lineHeight-xs:1.2;--lineHeight-sm:1.3189;--lineHeight-md:1.4;--lineHeight-lg:1.5;--lineHeight-xl:1.875;--transition-timing-slow:1s;--transition-timing-medium:500ms;--transition-timing-fast:150ms;--transition-timingFunction-in:cubic-bezier(0.4, 0, 1, 1);--transition-timingFunction-out:cubic-bezier(0, 0, 0.2, 1);--transition-timingFunction-in-out:cubic-bezier(0.4, 0, 0.2, 1);--transition-fast:var(--transition-timing-fast) 0ms var(--transition-timingFunction-in);--transition-medium:var(--transition-timing-medium) 0ms var(--transition-timingFunction-in);--transition-slow:var(--transition-timing-slow) 0ms var(--transition-timingFunction-in);--grid-side-gap-sm:var(--grid-gap-sm);--grid-side-gap-md:var(--grid-gap-md);--grid-side-gap-lg:var(--grid-gap-lg);--grid-gap-sm:1.5rem;--grid-gap-md:3.125rem;--grid-gap-lg:5rem;--grid-maxWidth-page:80rem;--grid-maxWidth-content:52.75rem;--spacing-2xs:.3125rem;--spacing-xs:.625rem;--spacing-sm:.75rem;--spacing-md:1rem;--spacing-lg:1.5rem;--spacing-xl:1.875rem;--spacing-2xl:2rem;--spacing-3xl:3.75rem;--spacing-4xl:4.375rem;--spacing-section:3rem;--spacing-section-lg:5rem;--borderRadius-xxs:0.125rem;--borderRadius-xs:0.375rem;--borderRadius-sm:0.625rem;--borderRadius-md:1rem;--borderRadius-lg:50px ;--borderRadius-xl:60px;--borderRadius-xxl:125px;--borderRadius-full:9999px;--boxShadow-light:0px 0px 8px rgba(0, 0, 0, 0.06);--boxShadow-medium:0px 0px 6px rgba(0, 0, 0, 0.16);--boxShadow-inset:inset 1px 1px 4px rgba(0, 0, 0, 0.06);--color-darkest:var(--color-navy);--color-lightest:#fff;--color-primary:#FE6B2E;--color-primary-light:#FE8B5B;--color-primary-dark:#E04201;--color-secondary:#65ABDC;--color-secondary-light:#EBF6FD;--color-secondary-dark:#152443;--color-eau-blue:var(--color-secondary);--color-light-blue:var(--color-secondary-light);--color-navy:var(--color-secondary-dark);--color-gray-100:#FDFDFE;--color-gray-200:#F3F3F6;--color-gray-300:#D6D6D6;--color-gray-400:#bababa;--color-gray-500:#707070;--color-gray-600:#5a5a5a;--color-gray-700:#454545;--color-gray-800:#313131;--color-gray-900:#101010;--color-light-gray:var(--color-gray-200);--color-stone-gray:var(--color-gray-500);--color-black-10:rgba(0, 0, 0, 0.05);--color-black-20:rgba(0, 0, 0, 0.16);--color-black-30:rgba(0, 0, 0, 0.24);--color-highlight-success:#3BDBB5;--color-highlight-info:var(--color-light-blue);--color-highlight-warning:var(--color-primary);--color-highlight-error:#E35C5C; }","type":"text/css"}],"script":[],"noscript":[]}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = false

export const purgeCachedData = true

export const granularCachedData = false

export const pendingWhenIdle = true

export const alwaysRunFetchOnKeyChange = true